const AboutData = 
    {
        id: 1,
        heading: 'My Self',
        subheading: 'UI/UX Designer & Web Developer',
        content: 'I`m Ryland Doe Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry`s standard dummy text              ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only                five centuries been the industry`s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to             make.',
        email: 'email@example.com',
        address: 'Los Angeles, USA',
        age: '21 Year',
        Nationality: 'USA'
    }


export default AboutData